<template>
	<Suspense>
		<PDFMakenPage />
	</Suspense>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";

const PDFMakenPage = defineAsyncComponent(
	() => import("@/pages/financiering/sections/PDFMakenPage.vue"),
);
</script>
